import React from "react";
import "./index.scss";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Col, Row } from "antd";

const SectionClient = (props) => {
  const { t } = useTranslation();
  return (
    <>
      <section className="section-client" id={props.id}>
        <Row>
          <Col className="decoration"></Col>
          <Col span={24} className="title">
            {t(props.title)}
          </Col>
          <Col span={24}>{props.children}</Col>
        </Row>
      </section>
    </>
  );
};

SectionClient.propTypes = {
  id: PropTypes.array,
  title: PropTypes.string,
  children: PropTypes.node,
};

export default SectionClient;
